import {SelectItemS} from "@app/core/components/select/Item.type";

export const propertyOwnershipStatusOptions: SelectItemS = [
  {value: "", key: "all"},
  {value: "true", key: "مالک"},
  {value: "false", key: "مستاجر"},
];

export const didWeContactOptions: SelectItemS = [
  {value: "", key: "هر دو"},
  {value: "true", key: "ما"},
  {value: "false", key: "مشتری"},
];

export const lockedStatusOptions: SelectItemS = [
  {value: "", key: "all"},
  {value: "true", key: "قفل است"},
  {value: "false", key: "قفل نیست"},
];
